export const mockPolicies = [
  {
    category: "Employee Policies",
    policies: [
      { name: "Probation Policy", description: "Define probation duration and eligibility for benefits." },
      { name: "Notice Period Policy", description: "Set notice period for resignations and terminations." },
      { name: "Remote Work Policy", description: "Rules for work-from-home approvals and limits." },
      { name: "Employee Role & Access Policy", description: "Define role-based permissions (e.g., HR, Manager, Employee)." }
    ]
  }
];


const extraPolicies = [
  ,
  {
    category: "Attendance Policies",
    policies: [
      { name: "Work Hours Policy", description: "Define standard daily work hours and working days." },
      { name: "Check-In / Check-Out Policy", description: "Grace period for late check-ins and threshold for early check-outs." },
      { name: "Overtime Policy", description: "Enable/disable overtime tracking and payment rules." },
      { name: "Shift Policy", description: "Configure shifts like Day/Night/Rotational." }
    ]
  },
  {
    category: "Leave Policies",
    policies: [
      { name: "Annual Leave Policy", description: "Define yearly leave entitlement and carry-forward rules." },
      { name: "Sick Leave Policy", description: "Set sick leave allowance; require medical proof after X days." },
      { name: "Casual Leave Policy", description: "Define casual leave per month/year." },
      { name: "Unpaid Leave Policy", description: "Set rules when unpaid leave applies." }
    ]
  },
  {
    category: "Payroll Policies",
    policies: [
      { name: "Salary Cycle Policy", description: "Monthly/bi-weekly cycle; salary credit date." },
      { name: "Tax & Deduction Policy", description: "Configure PF, ESI, and other deductions." },
      { name: "Bonus & Incentive Policy", description: "Rules for performance and festival bonuses." },
      { name: "Reimbursement Policy", description: "Rules for travel, food, and other reimbursements." }
    ]
  },
  {
    category: "General HRMS Policies",
    policies: [
      { name: "Holiday Calendar Policy", description: "Configure company-wide holidays." },
      { name: "Theme & Branding Policy", description: "Set default theme and upload logo." },
      { name: "Data Privacy & Compliance Policy", description: "Define how employee data is stored and shared." },
      { name: "Security Policy", description: "Password rules, session timeout, MFA." },
      { name: "Company Policy Documents", description: "Upload PDFs (e.g., Code of Conduct, HR Handbook)." }
    ]
  }]